/** Escape a cell for German Excel CSV (semicolon-separated). */
export function escapeCsvCell(value: string): string {
  if (/[;"\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/** Semicolon CSV with UTF-8 BOM for Excel. */
export function buildCsvDocument(headerRow: string[], dataRows: string[][]): string {
  const lines: string[] = [headerRow.map(escapeCsvCell).join(';')];
  for (const row of dataRows) {
    lines.push(row.map(escapeCsvCell).join(';'));
  }
  return `\uFEFF${lines.join('\r\n')}\r\n`;
}
